import dataSet from '!raw-loader!./../assets/data/ConFinder.txt'
export default {

  data() {
    return {
      dataSet: null,
     givenNames:[],
      givenNamesC:[],
      // Global caches for no-filter counts
      givenNamesAllC: null,
      familyNameAllC: null,
      countriesAllC: null,
      agesAllC: null,
      gendersAllC: null,
      shipsAllC: null,
      yearsAllC: null,
      tradesAllC: null,
      crimesAllC: null,
      // Pre-sorted caches for no-filter state
      givenNamesAll: null,
      familyNamesAll: null,
      familyNameAll: null,
      countriesAll: null,
      gendersAll: null,
      agesAll: null,
      shipsAll: null,
      yearsAll: null,
      tradesAll: null,
      crimesAll: null,
      // Pre-bucketed gender lists and toggle
      maleCons: [],
      femaleCons: [],
      unknownCons: [],
      useGenderBuckets: true,
      // Gender-specific name caches (built once at load)
      maleGivenCounts: null,
      femaleGivenCounts: null,
      maleFamilyCounts: null,
      femaleFamilyCounts: null,
      maleGiven: [],
      maleGivenC: [],
      femaleGiven: [],
      femaleGivenC: [],
      maleFamily: [],
      maleFamilyC: [],
      femaleFamily: [],
      femaleFamilyC: [],
      familyName:[],
      familyNameC:[],
      countries:[],
      countriesC:[],
      ages:[],
      agesC:[],
      genders:[],
      gendersC:[],
      ships:[],
      shipsC:[],
      years:[],
      yearsC:[],
      trades:[],
      tradesC:[],
      crimes:[],
      crimesC:[],
    }
  },
  mounted() { 
    
  },
  computed: {},
  methods: {
    resetData(){
      if(this.country){
        console.log("clear country")
        this.setCountry(null)
      }
      if(this.age){
        this.setAge(null)
      }
      if(this.gender){
        this.setGender(null)
      }
      if(this.ship){
        this.setShip(null)
      }
      if(this.trade){
        this.setTrade(null)
      }
      if(this.year){
        this.setYear(null)
      }
      if(this.crime){
        this.setCrime(null)
      }
      if(this.gName){
        console.log("clear given name")
        this.setGivenName(null)
      }
      if(this.fName){
        this.setFamilyName(null)
      }
     
      //this. allNames=[]
  },
    filterNames() {
      this.givenNames=[]
      this.givenNamesC=[]
      this.familyName=[]
      this.familyNameC=[]
      this.countries=[]
      this.countriesC=[]
      this.genders=[]
      this.gendersC=[]
      this.ships=[]
      this.shipsC=[]
      this.ages=[]
      this.agesC=[]
      this.trades=[]
      this.tradesC=[]
      this.crimes=[]
      this.crimesC=[]
      this.years=[]
      this.yearsC=[]
      this.possCount=0
      this.conIndex=0
      this.possCons=[]
      this.randomCons=[]
      // Gender-only fast path: if only gender is selected, skip filtering and use caches
      const isGenderOnly = !!this.gender && !this.gName && !this.fName && !this.country && !this.age && !this.trade && !this.crime && !this.ship && !this.year
      if (isGenderOnly) {
        const sortAlpha = (a,b)=> a.localeCompare(b, undefined, { sensitivity: 'base' })
        const bucket = this.gender === 'Male' ? this.maleCons : (this.gender === 'Female' ? this.femaleCons : this.unknownCons)
        this.possCount = bucket.length
        this.possCons = []
        // Given and family names from caches (Male/Female) or computed (Unknown)
        if (this.gender === 'Male') {
          this.givenNames = this.maleGiven.slice()
          this.givenNamesC = this.maleGivenC.slice()
          this.familyName = this.maleFamily.slice()
          this.familyNameC = this.maleFamilyC.slice()
        } else if (this.gender === 'Female') {
          this.givenNames = this.femaleGiven.slice()
          this.givenNamesC = this.femaleGivenC.slice()
          this.familyName = this.femaleFamily.slice()
          this.familyNameC = this.femaleFamilyC.slice()
        } else {
          const seenG = new Set(); const seenF = new Set();
          for (const con of this.unknownCons) { seenG.add(con.g); seenF.add(con.f); }
          this.givenNames = Array.from(seenG).sort(sortAlpha)
          this.givenNamesC = this.givenNames.map(n => ({ name: n, c: 1 }))
          this.familyName = Array.from(seenF).sort(sortAlpha)
          this.familyNameC = this.familyName.map(n => ({ name: n, c: 1 }))
        }
        // Build Countries, Ages, Trades, Crimes from selected gender bucket
        const cMap = Object.create(null), aMap = Object.create(null), tMap = Object.create(null), crMap = Object.create(null)
        for (const con of bucket) {
          cMap[con.c] = (cMap[con.c] || 0) + 1
          aMap[con.a] = (aMap[con.a] || 0) + 1
          tMap[con.t] = (tMap[con.t] || 0) + 1
          crMap[con.cr] = (crMap[con.cr] || 0) + 1
        }
        const mapToAlpha = (m) => {
          const names = Object.keys(m).sort(sortAlpha)
          return { names, pairs: names.map(n => ({ name: n, c: m[n] })) }
        }
        // Countries
        const countriesBuilt = mapToAlpha(cMap)
        this.countries = countriesBuilt.names
        this.countriesC = countriesBuilt.pairs
        // Trades
        const tradesBuilt = mapToAlpha(tMap)
        this.trades = tradesBuilt.names
        this.tradesC = tradesBuilt.pairs
        // Crimes
        const crimesBuilt = mapToAlpha(crMap)
        this.crimes = crimesBuilt.names
        this.crimesC = crimesBuilt.pairs
        // Ages: numeric sort with Unknown at end
        const ageKeys = Object.keys(aMap)
        ageKeys.sort((a,b) => {
          const an = Number(a), bn = Number(b)
          const aNum = Number.isFinite(an), bNum = Number.isFinite(bn)
          if (aNum && bNum) return an - bn
          if (aNum && !bNum) return -1
          if (!aNum && bNum) return 1
          return (a || '').toString().localeCompare((b || '').toString(), undefined, { sensitivity: 'base' })
        })
        this.ages = ageKeys
        this.agesC = ageKeys.map(n => ({ name: n, c: aMap[n] }))
        
        this.overlayState = "hidden"
        return
      }
      // Regular path
      if(this.fieldSelected){
        this.overlayState="visible"
        setTimeout( this.processName,10)
        //this.processName()
        
      }else{
        this.overlayState="visible"
        setTimeout( this.setAllGNames,10)
        //this.setAllGNames()
      }
      
      return
    },
    setUpData() {
    // Mark global prewarm active and initialize progress
    try {
      this.$store.commit('setDataInitActive', true)
      this.$store.commit('setDataInitProgress', { index: 0, max: this.progressMax || 75000, text: 'Accessing Database...' })
    } catch(e) {}
    // Robust line splitting across platforms (CRLF, LF, or CR) and ignore blanks
    const rawData = (typeof dataSet === 'string') ? dataSet : ((dataSet && dataSet.default) || '')
    this.dataSet = String(rawData).split(/\r\n|\n|\r/g).filter(l => l && l.trim().length > 0)
    this.allNames=[]
    // reset gender caches
    this.maleCons = []
    this.femaleCons = []
    this.unknownCons = []
    this.maleGivenCounts = Object.create(null)
    this.femaleGivenCounts = Object.create(null)
    this.maleFamilyCounts = Object.create(null)
    this.femaleFamilyCounts = Object.create(null)
    //console.log(this.dataSet)
    let nameArray
    let nameObj
    let tmpS,tmpCr,tmpT
    let valid
    this.possCount=0
      const total = this.dataSet.length
      for (let i = 0; i < total; i++) {
          const line = this.dataSet[i]
          if (typeof line !== 'string') continue
          const trimmed = line.trim()
          if (!trimmed) continue
          valid = true
          const nameArraySafe = trimmed.split("\t")
          if (!nameArraySafe || nameArraySafe.length < 10) continue
          nameArray = nameArraySafe
          tmpS=nameArray[3]
          if(tmpS=="M" || tmpS=="male" ) {
            tmpS="Male"
          } else if(tmpS=="F" ) {
            tmpS="Female"
          } else if(tmpS=="undefined") {
            tmpS="Unknown"
            valid=false
          }
          if(valid){
          this.possCount++
          tmpCr=nameArray[8]
          //if(Array.isArray(tmpCr)){
            tmpCr=tmpCr.split(",")[0]
          //}
          tmpT=nameArray[9]
         // if(Array.isArray(tmpT)){
          tmpT=tmpT.split(",")[0]
         // }
          if(nameArray[2]=="undefined"){
            nameArray[2]=""
          }
          nameObj={id:nameArray[0],g:nameArray[1],f:nameArray[2] ,s:tmpS,c:nameArray[4],a:(parseInt(nameArray[5],10) || "unknown"),sh:nameArray[6],ya:parseInt(nameArray[7],10) || "unknown",cr:tmpCr,t:tmpT }
          this.allNames.push( nameObj)
          // Fill gender-specific lists and build name counts for fast gender-only path
          if (tmpS === 'Male') {
            this.maleCons.push(nameObj)
            this.maleGivenCounts[nameObj.g] = (this.maleGivenCounts[nameObj.g] || 0) + 1
            this.maleFamilyCounts[nameObj.f] = (this.maleFamilyCounts[nameObj.f] || 0) + 1
          } else if (tmpS === 'Female') {
            this.femaleCons.push(nameObj)
            this.femaleGivenCounts[nameObj.g] = (this.femaleGivenCounts[nameObj.g] || 0) + 1
            this.femaleFamilyCounts[nameObj.f] = (this.femaleFamilyCounts[nameObj.f] || 0) + 1
          } else {
            this.unknownCons.push(nameObj)
          }
          if (i % 1000 === 0) {
            try {
              // Map parse progress to ~0-15k of 75k to leave room for later stages
              this.$store.commit('setDataInitProgress', { index: Math.min(15000, Math.floor((i/Math.max(1,total))*15000)), max: this.progressMax || 75000, text: 'Accessing Database...' })
            } catch(e) {}
          }
      }
       
      }
      console.log("ALLNAMES",this.possCount)
      this.$store.commit("setAllCons",this.allNames)
      // Build presorted caches for no-filter state
      const alpha = (a,b)=> (a||'').toString().localeCompare((b||'').toString(), undefined, { sensitivity: 'base' })
      const numSort = (a,b)=>{
        const an = Number(a), bn = Number(b)
        const aNum = Number.isFinite(an), bNum = Number.isFinite(bn)
        if (aNum && bNum) return an - bn
        if (aNum && !bNum) return -1
        if (!aNum && bNum) return 1
        return alpha(a,b)
      }
      const uniq = (arr) => Array.from(new Set(arr))
      this.givenNamesAll = uniq(this.allNames.map(n=>n.g)).sort(alpha)
      const famAll = uniq(this.allNames.map(n=>n.f)).sort(alpha)
      this.familyNamesAll = famAll
      this.familyNameAll = famAll
      this.countriesAll = uniq(this.allNames.map(n=>n.c)).sort(alpha)
      this.gendersAll = uniq(this.allNames.map(n=>n.s)).sort(alpha)
      this.agesAll = uniq(this.allNames.map(n=>n.a)).sort(numSort)
      this.shipsAll = uniq(this.allNames.map(n=>n.sh)).sort(alpha)
      this.yearsAll = uniq(this.allNames.map(n=>n.ya)).sort(numSort)
      this.tradesAll = uniq(this.allNames.map(n=>n.t)).sort(alpha)
      this.crimesAll = uniq(this.allNames.map(n=>n.cr)).sort(alpha)
      // Finalize gender-specific sorted arrays
      const sortAlpha = (a,b)=> a.localeCompare(b, undefined, { sensitivity: 'base' })
      const buildArrays = (countsObj) => {
        const names = Object.keys(countsObj)
        names.sort(sortAlpha)
        const pairs = names.map(n => ({ name: n, c: countsObj[n] }))
        return { names, pairs }
      }
      const maleGiven = buildArrays(this.maleGivenCounts)
      this.maleGiven = maleGiven.names
      this.maleGivenC = maleGiven.pairs
      const femaleGiven = buildArrays(this.femaleGivenCounts)
      this.femaleGiven = femaleGiven.names
      this.femaleGivenC = femaleGiven.pairs
      const maleFamily = buildArrays(this.maleFamilyCounts)
      this.maleFamily = maleFamily.names
      this.maleFamilyC = maleFamily.pairs
      const femaleFamily = buildArrays(this.femaleFamilyCounts)
      this.femaleFamily = femaleFamily.names
      this.femaleFamilyC = femaleFamily.pairs
      // Build no-filter global count caches once
      const inc = (map, key) => { map[key] = (map[key] || 0) + 1 }
      const gMap = Object.create(null)
      const fMap = Object.create(null)
      const cMap = Object.create(null)
      const sMap = Object.create(null)
      const aMap = Object.create(null)
      const shMap = Object.create(null)
      const yaMap = Object.create(null)
      const tMap = Object.create(null)
      const crMap = Object.create(null)
      for (const con of this.allNames) {
        inc(gMap, con.g)
        inc(fMap, con.f)
        inc(cMap, con.c)
        inc(sMap, con.s)
        inc(aMap, con.a)
        inc(shMap, con.sh)
        inc(yaMap, con.ya)
        inc(tMap, con.t)
        inc(crMap, con.cr)
      }
      const numSortPairs = (pairs) => pairs.sort((x,y)=>{
        const xn = Number(x.name), yn = Number(y.name)
        const xNum = Number.isFinite(xn), yNum = Number.isFinite(yn)
        if (xNum && yNum) return xn - yn
        if (xNum && !yNum) return -1
        if (!xNum && yNum) return 1
        return String(x.name).localeCompare(String(y.name), undefined, { sensitivity: 'base' })
      })
      this.givenNamesAllC = buildArrays(gMap).pairs
      this.familyNameAllC = buildArrays(fMap).pairs
      this.countriesAllC = buildArrays(cMap).pairs
      this.gendersAllC = buildArrays(sMap).pairs
      this.agesAllC = numSortPairs(buildArrays(aMap).pairs)
      this.shipsAllC = buildArrays(shMap).pairs
      this.yearsAllC = numSortPairs(buildArrays(yaMap).pairs)
      this.tradesAllC = buildArrays(tMap).pairs
      this.crimesAllC = buildArrays(crMap).pairs
      try {
        this.$store.commit('setDataInitProgress', { index: 20000, max: this.progressMax || 75000, text: 'Preparing Lists...' })
      } catch(e) {}
      // Cache computed collections in Vuex for subsequent visits
      try {
        this.$store.commit('setFieldsCache', {
          givenNamesAll: this.givenNamesAll,
          givenNamesAllC: this.givenNamesAllC,
          familyNamesAll: this.familyNamesAll,
          familyNameAll: this.familyNameAll,
          familyNameAllC: this.familyNameAllC,
          countriesAll: this.countriesAll,
          countriesAllC: this.countriesAllC,
          gendersAll: this.gendersAll,
          gendersAllC: this.gendersAllC,
          agesAll: this.agesAll,
          agesAllC: this.agesAllC,
          shipsAll: this.shipsAll,
          shipsAllC: this.shipsAllC,
          yearsAll: this.yearsAll,
          yearsAllC: this.yearsAllC,
          tradesAll: this.tradesAll,
          tradesAllC: this.tradesAllC,
          crimesAll: this.crimesAll,
          crimesAllC: this.crimesAllC,
          maleCons: this.maleCons,
          femaleCons: this.femaleCons,
          unknownCons: this.unknownCons,
          maleGiven: this.maleGiven,
          maleGivenC: this.maleGivenC,
          femaleGiven: this.femaleGiven,
          femaleGivenC: this.femaleGivenC,
          maleFamily: this.maleFamily,
          maleFamilyC: this.maleFamilyC,
          femaleFamily: this.femaleFamily,
          femaleFamilyC: this.femaleFamilyC,
        })
        this.$store.commit('setDataInitDone', true)
      } catch (e) {
        // no-op if store not available
      }
      this.overlayText="Sorting Given Names..."
      this.filterNames()
    },
    setGivenName(val){
      if (this.gName === val) return
      this.gName=val
      this.filterNames()
    },
    setFamilyName(val){
      if (this.fName === val) return
      this.fName=val
      this.filterNames()
    },
    setCountry(val){
      if (this.country === val) return
      this.country=val
      this.filterNames()
    },
    setGender(val){
      if (this.gender === val) return
      this.gender=val
      this.filterNames()
    },
    setAge(val){
      if (this.age === val) return
      this.age=val
      this.filterNames()
    },
    setTrade(val){
      if (this.trade === val) return
      this.trade=val
      this.filterNames()
    },
    setCrime(val){
      if (this.crime === val) return
      this.crime=val
      this.filterNames()
    },
    setShip(val){
      if (this.ship === val) return
      this.ship=val
      this.filterNames()
    },
    setYear(val){
      if (this.year === val) return
      this.year=val
      this.filterNames()
    },
    processName(){
    
      let con
      let ai
      const src = (this.useGenderBuckets && this.gender)
        ? (this.gender === 'Male' ? this.maleCons : (this.gender === 'Female' ? this.femaleCons : this.unknownCons))
        : this.allNames
      for(var c =0;c<this.maxCons && this.conIndex<src.length;c++){
        con=src[this.conIndex]
        con.poss=true
        if(con.poss && this.gName && con.g.indexOf(this.gName)!=0){
          con.poss = false
        }
        if(con.poss && this.fName){
          if (this.fName === '-') {
            if (con.f !== '' && con.f !== undefined && con.f !== null) {
              con.poss = false
            }
          } else if (this.fName != con.f) {
            con.poss = false
          }
        }
        if(con.poss && this.country && this.country!=con.c){
          con.poss = false
        }
        if(con.poss && this.gender && this.gender!=con.s){
          con.poss = false
        }
        if(con.poss && this.age && this.age!=con.a){
          con.poss = false
        }
        if(con.poss && this.trade && this.trade!=con.t){
          con.poss = false
        }
        if(con.poss && this.crime && this.crime!=con.cr){
          con.poss = false
        }
        if(con.poss && this.ship && this.ship!=con.sh){
          con.poss = false
        }
        if(con.poss && this.year && this.year!=con.ya){
          con.poss = false
        }
        if(con.poss){
          this.possCount++
          if(this.possCons.length<=5000){
            this.possCons.push(con)
          }
          //single name test
          //con.g=con.g.split(" ")[0]
          // if( !this.givenNames.includes(con.g.split(" ")[0]) ){
          //   this.givenNames.push(con.g)
          // }
          ai=this.givenNames.indexOf(con.g)
          if(!this.gName && ai ==-1){
            this.givenNames.push(con.g)
            this.givenNamesC.push({name:con.g,c:1})
          }else{
            if(this.givenNamesC[ai] && this.givenNamesC[ai].c){
              this.givenNamesC[ai].c++
            }else{
              this.givenNamesC.push({name:con.g,c:1})
            }
          }

          // if(!this.fName && !this.familyName.includes(con.f) ){
          //   this.familyName.push( con.f)
          // }
          ai=this.familyName.indexOf(con.f)
          if(!this.fName && ai ==-1){
            this.familyName.push(con.f)
            this.familyNameC.push({name:con.f,c:1})
          }else{
            if(this.familyNameC[ai] && this.familyNameC[ai].c){
              this.familyNameC[ai].c++
            }else{
              this.familyNameC.push({name:con.f,c:1})
            }
          }
          // if(!this.country && !this.countries.includes(con.c) ){
          //   this.countries.push( con.c)
          // }
          
          ai=this.countries.indexOf(con.c)
          if(!this.country && ai ==-1){
            this.countries.push(con.c)
            this.countriesC.push({name:con.c,c:1})
          }else{
            if(this.countriesC[ai] && this.countriesC[ai].c){
              this.countriesC[ai].c++
            }else{
              this.countriesC.push({name:con.c,c:1})
            }
          }
          if(!this.gender){
            ai = this.genders.indexOf(con.s)
            if (ai === -1) {
              this.genders.push(con.s)
              this.gendersC.push({ name: con.s, c: 1 })
            } else {
              if (this.gendersC[ai] && this.gendersC[ai].c) {
                this.gendersC[ai].c++
              } else {
                this.gendersC.push({ name: con.s, c: 1 })
              }
            }
          }
          // if(!this.age && !this.ages.includes(con.a) ){
          //   this.ages.push( con.a)
          // }
          
           ai=this.ages.indexOf(con.a)
          if(!this.age && ai ==-1){
            this.ages.push(con.a)
            this.agesC.push({name:con.a,c:1})
          }else{
            if(this.agesC[ai] && this.agesC[ai].c){
              this.agesC[ai].c++
            }else{
              this.agesC.push({name:con.a,c:1})
            }
          }
          ai=this.trades.indexOf(con.t)
          if(!this.trade && ai ==-1){
            this.trades.push(con.t)
            this.tradesC.push({name:con.t,c:1})
          }else{
            if(this.tradesC[ai] && this.tradesC[ai].c){
              this.tradesC[ai].c++
            }else{
              this.tradesC.push({name:con.t,c:1})
            }
          }
          ai = this.crimes.indexOf(con.cr)
          if (!this.crime && ai == -1) {
            this.crimes.push(con.cr)
            this.crimesC.push({ name: con.cr, c: 1 })
          } else {
            if (this.crimesC[ai] && this.crimesC[ai].c) {
              this.crimesC[ai].c++
            } else {
              this.crimesC.push({ name: con.cr, c: 1 })
            }
          }
          ai = this.ships.indexOf(con.sh)
          if (!this.ship && ai == -1) {
            this.ships.push(con.sh)
            this.shipsC.push({ name: con.sh, c: 1 })
          } else {
            if (this.shipsC[ai] && this.shipsC[ai].c) {
              this.shipsC[ai].c++
            } else {
              this.shipsC.push({ name: con.sh, c: 1 })
            }
          }
          // if (!this.year && !this.years.includes(con.ya)) {
          //   this.years.push(con.ya)
          // }
          ai = this.years.indexOf(con.ya)
          if (!this.year && ai == -1) {
            this.years.push(con.ya)
            this.yearsC.push({ name: con.ya, c: 1 })
          } else {
            if (this.yearsC[ai] && this.yearsC[ai].c) {
              this.yearsC[ai].c++
            } else {
              this.yearsC.push({ name: con.ya, c: 1 })
            }
          }
        }
        this.conIndex++
        try {
          this.$store.commit('setDataInitProgress', { index: Math.max(30000, this.conIndex), max: this.progressMax || 75000, text: this.overlayText || 'Filtering Data...' })
        } catch(e) {}
      }
      //console.log(this.conIndex)
      if (this.optionsShown && false) {
        console.log("WAIT")
        this.waitForOptions()
      } else {
        if (this.conIndex < src.length - 1) {
          this.overlayText = "Filtering Data..."
          setTimeout(this.processName, 10)
        } else {
          // Ensure stable sorted order for all dropdowns
          const alpha = (a, b) => (a || '').toString().localeCompare((b || '').toString(), undefined, { sensitivity: 'base' })
          const alphaByName = (a, b) => (a?.name || '').toString().localeCompare((b?.name || '').toString(), undefined, { sensitivity: 'base' })
          const numKey = (v) => {
            const raw = (v?.name !== undefined) ? v.name : v
            const n = Number(raw)
            return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY
          }
          // Given names
          if (this.givenNamesC && this.givenNamesC.length > 1) this.givenNamesC.sort(alphaByName)
          if (this.givenNames && this.givenNames.length > 1) this.givenNames.sort(alpha)
          // Family names
          if (this.familyNameC && this.familyNameC.length > 1) this.familyNameC.sort(alphaByName)
          if (this.familyName && this.familyName.length > 1) this.familyName.sort(alpha)
          // Countries
          if (this.countriesC && this.countriesC.length > 1) this.countriesC.sort(alphaByName)
          if (this.countries && this.countries.length > 1) this.countries.sort(alpha)
          // Genders
          if (this.genders && this.genders.length > 1) this.genders.sort(alpha)
          // Ages (numeric, Unknown at end)
          if (this.agesC && this.agesC.length > 1) this.agesC.sort((a,b) => numKey(a) - numKey(b) || alphaByName(a,b))
          if (this.ages && this.ages.length > 1) this.ages.sort((a,b) => numKey(a) - numKey(b) || alpha(a,b))
          // Trades
          if (this.tradesC && this.tradesC.length > 1) this.tradesC.sort(alphaByName)
          if (this.trades && this.trades.length > 1) this.trades.sort(alpha)
          // Crimes
          if (this.crimesC && this.crimesC.length > 1) this.crimesC.sort(alphaByName)
          if (this.crimes && this.crimes.length > 1) this.crimes.sort(alpha)
          // Ships
          if (this.shipsC && this.shipsC.length > 1) this.shipsC.sort(alphaByName)
          if (this.ships && this.ships.length > 1) this.ships.sort(alpha)
          // Years (numeric, Unknown at end)
          if (this.yearsC && this.yearsC.length > 1) this.yearsC.sort((a,b) => numKey(a) - numKey(b) || alphaByName(a,b))
          if (this.years && this.years.length > 1) this.years.sort((a,b) => numKey(a) - numKey(b) || alpha(a,b))

          this.overlayState = "hidden"
          try {
            this.$store.commit('setDataInitProgress', { index: this.progressMax || 75000, max: this.progressMax || 75000, text: 'Ready' })
            this.$store.commit('setDataInitActive', false)
          } catch(e) {}
          // this.givenNames.sort()
          // this.familyName.sort()
          // console.log("Sort ages")
          // this.ages.sort()
          // this.trades.sort()
          // this.years.sort()
        }
      }
    },
  }
}
